<template>
<div>
   <div v-for="(faq, index) in compLost" :key="index" class="faq">
        <div v-on:click="changeOpen(index)" class="faq-question">
          <div class="icon-wrapper">
            <img v-if="!faq.open" src="@/assets/icons/plus.png" alt="open faq icon">
            <img v-else src="@/assets/icons/minus.png" class="minus-icon" alt="open faq icon">
          </div>
          <span>{{ getT(faq.question) }}</span>
         </div>
         <div v-if="faq.open" class="faq-answer">
            <div class="ul" v-html="getT(faq.answer)">
            </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'aboutWhy',
  data () {
    return {
      list: [
        {
          question: 'about.list.question1',
          answer: 'about.list.reason1Q1',
          open: false
        },
        {
          question: 'about.list.question2',
          answer: 'about.list.reason1Q2',
          open: false
        },
        {
          question: 'about.list.question3',
          answer: 'about.list.reason1Q3',
          open: false
        },
        {
          question: 'about.list.question4',
          answer: 'about.list.reason1Q4',
          open: false
        },
        {
          question: 'about.list.question5',
          answer: 'about.list.reason1Q5',
          open: false
        },
        {
          question: 'about.list.question6',
          answer: 'about.list.reason1Q6',
          open: false
        }
      ]
    }
  },
  computed: {
    listData: function () {
      return [
        {
          question: this.$t('about.list.question1'),
          answer: this.$t('about.list.reason1Q1'),
          open: false
        },
        {
          question: this.$t('about.list.question2'),
          answer: this.$t('about.list.reason1Q2'),
          open: false
        },
        {
          question: this.$t('about.list.question3'),
          answer: this.$t('about.list.reason1Q3'),
          open: false
        },
        {
          question: this.$t('about.list.question4'),
          answer: this.$t('about.list.reason1Q4'),
          open: false
        },
         {
          question: this.$t('about.list.question5'),
          answer: this.$t('about.list.reason1Q5'),
          open: false
        },
        {
          question: this.$t('about.list.question6'),
          answer: this.$t('about.list.reason1Q6'),
          open: false
        }
      ]
    },
    compLost: {
      get: function () {
        return this.list
      },
      set: function () {
        console.log('set')
        this.list = new Array(...this.list)
      }
    }
  },
  methods: {
    changeOpen (x) {
      console.log(this.list[x].open)
      this.list[x].open = !this.list[x].open
      console.log(this.list[x].open + ' ' + this.list[x].question)
    },
    getT (str) {
      return this.$t(str)
    }
  }
}
</script>

<style lang="scss" scoped>
.faq {
      min-height: 70px;
      border-bottom: 1px solid #F2F2F2;

      .faq-question {
        font-weight: 600;
        font-size: 19px;
        line-height: 31px;
        letter-spacing: 0.06em;
        text-align: left;
        color: #4B4B4B;
        height: 70px;
        display: flex;
        align-items: center;
        cursor: pointer;

        .icon-wrapper {
          width: 30px;

          .minus-icon {
            margin-bottom: 5px;
          }
        }
      }
      .faq-answer {
        font-weight: 500;
        font-size: 15px;
        line-height: 22px;
        text-align: left;
        letter-spacing: 0.02em;
        color: #777777;
        margin-top: 10px;
        margin-bottom: 30px;
        padding-left: 30px;
      }
      .ul{
        margin: 0;
        padding:0;
         .line {
          display: inline-block;
          text-decoration: underline !important;
          text-decoration-line: underline;
          color:red;
      }
      }
      .ul li{
        padding: 1.4% 0;
        margin-left: 0;
      }
     
}
@media only screen and (max-width: 768px) {
  .faq{
     .faq-question {
        font-weight: 600;
        font-size: 16px;
        text-align: left;
        color: #4B4B4B;
        display: flex;
        align-items: center;
        cursor: pointer;

        .icon-wrapper {
          width: 30px;
          padding-right: 5px;

          .minus-icon {
            margin-bottom: 5px;
          }
        }
      }
  }
  }
  @media only screen and (max-width: 430px) {
  .faq{
    padding-bottom:15px;
     .faq-question {
        height: fit-content;
        cursor: pointer;

        .icon-wrapper {
          width: 30px;
          padding-right: 5px;

          .minus-icon {
            margin-bottom: 5px;
          }
        }
      }
  }
  }
</style>
